export default __webpack_public_path__ + "static/media/Venturer's Helm.394940cd.jpg";